import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { VehicleCreatePayload, VehicleUpdatePayload } from '@/interfaces/IVehicle';

/**
 * VehicleAPI - API controller for vehicles
 * Handles all CRUD operations for vehicles
 */
export default class VehicleAPI {
    /**
     * Get all vehicles
     * GET /vehicles
     */
    public static async getAll(): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.vehicles.getAll);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get a single vehicle by ID
     * GET /vehicles/{id}
     */
    public static async getById(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.vehicles.getById(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Create a new vehicle
     * POST /vehicles
     */
    public static async create(payload: VehicleCreatePayload): Promise<AxiosResponse> {
        const request = {
            data: {
                attributes: {
                    ...payload,
                },
                type: 'vehicles',
            },
        };

        try {
            const response = await ApiController.post(ApiRoutes.vehicles.create, request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update an existing vehicle
     * PATCH /vehicles/{id}
     */
    public static async update(id: string, payload: VehicleUpdatePayload): Promise<AxiosResponse> {
        const request = {
            data: {
                attributes: {
                    ...payload,
                },
                type: 'vehicles',
                id,
            },
        };

        try {
            const response = await ApiController.patch(ApiRoutes.vehicles.update(id), request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Delete a vehicle
     * DELETE /vehicles/{id}
     */
    public static async delete(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.delete(ApiRoutes.vehicles.delete(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
